import { ReactElement } from 'react';
import { tokens } from '../../theme';

/** Faixa com as cores da marca Ferreira Costa, usada no topo do Header. */
export const FCBar = (): ReactElement => {
  return (
    <div style={styles.bar} role="presentation">
      <div style={{ ...styles.half, backgroundColor: tokens.colors.brand.stripe.main }} />
      <div style={styles.stripes}>
        <div style={{ ...styles.stripe, backgroundColor: tokens.colors.brand.stripe.main }} />
        <div style={{ ...styles.stripe, backgroundColor: tokens.colors.brand.stripe.secondary }} />
        <div style={{ ...styles.stripe, backgroundColor: tokens.colors.brand.stripe.secondary }} />
        <div style={{ ...styles.stripe, backgroundColor: tokens.colors.brand.stripe.tertiary }} />
        <div style={{ ...styles.stripe, backgroundColor: tokens.colors.brand.stripe.quaternary }} />
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  bar: {
    display: 'flex',
    width: '100%',
    height: tokens.borderWidth.stripe,
  },
  half: {
    flex: 1,
    height: tokens.borderWidth.stripe,
  },
  stripes: {
    flex: 1,
    display: 'flex',
  },
  stripe: {
    flex: 1,
    height: tokens.borderWidth.stripe,
  },
};
